import { IncidentsGridWebComponent } from './component/IncidentsGridWebComponent';
import { WEB_COMPONENT_INCIDENTS_GRID } from '../../webcomponents.constants';

export { IncidentsGridWebComponent };

window.customElements.define(WEB_COMPONENT_INCIDENTS_GRID, IncidentsGridWebComponent);
